import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ScriptLoaderService } from '../_services/script-loader.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PrintReportComponent } from '../shared/components/print-report/print-report.component';
import { appService } from '../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../shared/services/commen/commen.services';

@Component({
  selector: 'app-confirm-order-download-pdf',
  templateUrl: './confirm-order-download-pdf.component.html',
  styleUrls: ['./confirm-order-download-pdf.component.scss']
})
export class ConfirmOrderDownloadPdfComponent implements OnInit {

  static that: ConfirmOrderDownloadPdfComponent;
  OrderId: any;
  isMobileView: boolean = false;
  CompanyId: any;
  OrderNo: any;
  @ViewChild(PrintReportComponent) PrintReportChild: PrintReportComponent;
  public POReportHtml: SafeHtml;
  IsDownloadStickerDisable: boolean = false;
  IsDownloadPoDisable: boolean = false;
  IsDownloadBoth: boolean = false;
  PoReportElement: any;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _script: ScriptLoaderService,
    private sanitizer: DomSanitizer,
    private _appService: appService,
    private toastr: ToastrService,
    private commonService: CommonService,
  ) { 
    ConfirmOrderDownloadPdfComponent.that = this;
  }

  ngOnInit() {
    this._script.loadScripts("body",
      [
        "assets/vendors/base/vendors.bundle.js",
        "assets/demo/default/base/scripts.bundle.js"
      ],
      true
    ).then(() => {
      this._activatedRoute.params.subscribe((params: Params) => {
        this.OrderId = this._activatedRoute.snapshot.queryParams["OrderId"];
        if(this.OrderId){
          this.GetCompanyId(this.OrderId);
          // setTimeout(() => {
          //   this.PremvatiPurchaseOrder(this.OrderId);
          // }, 400);
        }
      });
    });
  }

  GetCompanyId(OrderId: any) {
    this._appService.GetById("OrdersByVehicle", "GetCompanyByOrderId", OrderId).subscribe((response) => {
      this.CompanyId = response[0].CompanyId;
      this.OrderNo = response[0].OrderNo;
      this.PremvatiPurchaseOrder(OrderId);
    });
  }


  async PremvatiPurchaseOrder(Id) {
    this.PrintReportChild.divElements = null;
    this.PrintReportChild.CompanyId = this.CompanyId;
    this.PrintReportChild.OrderId = Id;
    this.PrintReportChild.ReportType = 'Purchase Order Premvati';
    this.PrintReportChild.OnlyHtmlView = true;

    // Create a promise that resolves when child emits event
    await new Promise<void>((resolve) => {
      const sub = this.PrintReportChild.renderComplete.subscribe(() => {
        resolve();
        sub.unsubscribe(); // avoid memory leaks
      });

      this.PrintReportChild.PrintInvoice();
    });

    var rawHtml = this.PrintReportChild.divElements;
    this.PoReportElement = this.PrintReportChild.divElements
    this.POReportHtml = this.sanitizer.bypassSecurityTrustHtml(rawHtml);
    console.log('POReportHtml', this.POReportHtml)
  }

  async DownloadSticker() {
    this.IsDownloadStickerDisable = true;
    try {
      this.PrintReportChild.CompanyId = this.CompanyId;
      this.PrintReportChild.OrderId = this.OrderId;
      this.PrintReportChild.PONo = this.OrderNo;
      this.PrintReportChild.ReportType = 'Print Sticker';
      // await new Promise<void>((resolve) => {
      //   const sub = this.PrintReportChild.renderComplete.subscribe(() => {
      //     resolve();
      //     sub.unsubscribe();
      //   });
      //   this.PrintReportChild.PrintSticker();
      // });
      const stickerPromise = new Promise<void>((resolve) => {
        const sub = this.PrintReportChild.renderComplete.subscribe(() => {
          console.log("Render Complete event fired!");
          resolve();
          sub.unsubscribe();
        });
      });

      // Call AFTER subscription is attached
      this.PrintReportChild.PrintSticker();

      await stickerPromise;
    } catch (error) {
      console.error("Error while downloading sticker:", error);
    } finally {
      this.IsDownloadStickerDisable = false;
    }
  }

  async DownloadPo() {
    this.IsDownloadPoDisable = true;
    try {
      this.PrintReportChild.divElements = null;
      this.PrintReportChild.CompanyId = this.CompanyId;
      this.PrintReportChild.OrderId = this.OrderId;
      this.PrintReportChild.ReportType = 'Purchase Order Premvati';
      this.PrintReportChild.OnlyHtmlView = true;
      await new Promise<void>((resolve, reject) => {
        const sub = this.PrintReportChild.renderComplete.subscribe({
          next: () => {
            resolve();
            sub.unsubscribe();
          },
          error: (err) => {
            reject(err);
            sub.unsubscribe();
          }
        });
        this.PrintReportChild.PrintInvoice();
      });
      this.PoReportElement = this.PrintReportChild.divElements;
      const obj = {
        POReportHtml: this.PoReportElement,
        PoNo: this.OrderNo
      };
      this._appService.Post("OrdersByVehicle", "DownloadPOReport", obj).subscribe({
        next: (response) => {
          this.DownloadFile(response);
        },
        error: (err) => {
          this.toastr.error(err._body.replace(/"/g, "") || "Error occurred", "Error");
        },
        complete: () => {
          this.IsDownloadPoDisable = false;
        }
      });
    } catch (error) {
      console.error("Error during PO download:", error);
      this.toastr.error("An unexpected error occurred while downloading the PO.", "Error");
      this.IsDownloadPoDisable = false;
    }
  }

  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(FileContent.Content, FileContent.ContentType);
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileTyreReport").attr('href', url);
    $("#DownLoadFileTyreReport").attr('download', FileContent.FileName);
    let element: HTMLElement = document.getElementById("DownLoadFileTyreReport") as HTMLElement;
    element.attributes
    element.click();
  }

  // async DownloadBothPdf() {
  //   this.IsDownloadBoth = true;
  //   try {
  //     await this.DownloadPo();
  //     await this.DownloadSticker();
  //     this.toastr.success("Both PDFs downloaded successfully!", "Success");
  //   } catch (error) {
  //     console.error("Error while downloading both PDFs:", error);
  //     this.toastr.error("Error occurred while downloading both PDFs", "Error");
  //   } finally {
  //     this.IsDownloadBoth = false;
  //   }
  // }

  async DownloadBothPdf() {
    this.IsDownloadBoth = true; // Only disable the combined button
    try {
      // Download PO
      this.PrintReportChild.divElements = null;
      this.PrintReportChild.CompanyId = this.CompanyId;
      this.PrintReportChild.OrderId = this.OrderId;
      this.PrintReportChild.ReportType = 'Purchase Order Premvati';
      this.PrintReportChild.OnlyHtmlView = true;

      await new Promise<void>((resolve, reject) => {
        const sub = this.PrintReportChild.renderComplete.subscribe({
          next: () => {
            sub.unsubscribe();
            resolve();
          },
          error: (err) => {
            sub.unsubscribe();
            reject(err);
          }
        });
        this.PrintReportChild.PrintInvoice();
      });

      this.PoReportElement = this.PrintReportChild.divElements;
      const obj = { POReportHtml: this.PoReportElement, PoNo: this.OrderNo };

      await new Promise<void>((resolve, reject) => {
        this._appService.Post("OrdersByVehicle", "DownloadPOReport", obj)
          .subscribe(
            (response: any) => {
              this.DownloadFile(response);
              resolve();
            },
            (err: any) => {
              this.toastr.error("Error occurred", "Error");
              reject(err);
            }
          );
      });

      // Download Sticker
      this.PrintReportChild.CompanyId = this.CompanyId;
      this.PrintReportChild.OrderId = this.OrderId;
      this.PrintReportChild.PONo = this.OrderNo;
      this.PrintReportChild.ReportType = 'Print Sticker';

      await new Promise<void>((resolve, reject) => {
        const sub = this.PrintReportChild.renderComplete.subscribe({
          next: () => { sub.unsubscribe(); resolve(); },
          error: (err) => { sub.unsubscribe(); reject(err); }
        });
        this.PrintReportChild.PrintSticker();
      });

      this.toastr.success("Both PDFs downloaded successfully!", "Success");
    } catch (error) {
      console.error("Error while downloading both PDFs:", error);
      this.toastr.error("Error occurred while downloading both PDFs", "Error");
    } finally {
      this.IsDownloadBoth = false; // ✅ Only this button is disabled
      // Individual buttons remain enabled
    }
  }


}
